var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpecialInstructions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 205,
    height: 205,
    viewBox: "0 0 205 205",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4675_13078",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 205,
    height: 205
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.52588e-05H205V205H0V1.52588e-05Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4675_13078)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.715 28.2666V187.208C186.715 195.368 180.099 201.996 171.926 201.996M47.8523 144.158V3.00197H186.715V14.6589M47.8523 169.422V157.767",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0637 201.996C24.9033 201.996 18.2869 195.368 18.2869 187.207V169.422H157.138V187.207C157.138 195.368 163.766 201.996 171.926 201.996H33.0637Z",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.9041 80.9141C95.1009 80.9141 100.163 75.8411 100.163 69.6555V48.8516H77.6455V69.6555C77.6455 75.8411 82.7185 80.9141 88.9041 80.9141Z",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.163 48.8438V28.0399C100.163 21.843 95.1005 16.7697 88.9041 16.7697C82.7185 16.7697 77.6455 21.843 77.6455 28.0399V48.8438H100.163Z",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.1 30.4084C145.288 22.1684 135.709 16.7771 124.859 16.7771C114.928 16.7771 106.053 21.2939 100.162 28.3876V69.3035C106.053 76.3969 114.928 80.9141 124.859 80.9141C142.565 80.9141 156.923 66.5569 156.923 48.8516C156.923 46.808 156.73 44.8108 156.366 42.8697",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.319 77.4727L110.4 20.2136",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.8314 110.245H167.58M66.9885 110.245H71.1878M83.8314 123.854H167.58M66.9885 123.854H71.1878M83.8314 137.451H167.58M66.9885 137.451H71.1878M83.8314 151.059H167.58M66.9885 151.059H71.1878M105.078 96.6483H129.491",
    stroke: "#7f56d9",
    strokeWidth: 6.01547,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialInstructions);
export default __webpack_public_path__ + "static/media/specialInstructions.6ff64db277b204628b30925bc377b2e6.svg";
export { ForwardRef as ReactComponent };